namespace TabAurous.HR {
    export interface HolidayListRow {
        HolidayListId?: number;
        Code?: string;
        Description?: string;
        StartDate?: string;
        EndDate?: string;
        Holidays?: HolidaysRow[];
    }

    export namespace HolidayListRow {
        export const idProperty = 'HolidayListId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'HR.HolidayList';
        export const deletePermission = 'HR:HolidayList:Delete';
        export const insertPermission = 'HR:HolidayList:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:HolidayList:Edit';

        export declare const enum Fields {
            HolidayListId = "HolidayListId",
            Code = "Code",
            Description = "Description",
            StartDate = "StartDate",
            EndDate = "EndDate",
            Holidays = "Holidays"
        }
    }
}
